export type BesideSide = 'left' | 'right';

/** Side a beside-tooltip opens on: the preferred one, unless it lacks room and the other side has more. */
export function pickBesideSide(
    preferred: BesideSide,
    anchor: { left: number; right: number },
    neededWidth: number,
    viewportWidth: number,
    edgePadding: number,
): BesideSide {
    const room = { right: viewportWidth - edgePadding - anchor.right, left: anchor.left - edgePadding };
    const other: BesideSide = preferred === 'right' ? 'left' : 'right';
    return room[preferred] < neededWidth && room[other] > room[preferred] ? other : preferred;
}

/** Nearest ancestor that scrolls vertically — its box is the visible area beneath any fixed page chrome. */
export function closestScrollContainer(from: HTMLElement | null): HTMLElement | null {
    for (let el = from?.parentElement ?? null; el; el = el.parentElement) {
        if (/auto|scroll|overlay/.test(getComputedStyle(el).overflowY)) return el;
    }
    return null;
}
